import { data } from '../../svg/Templates/data';
import { makeIcon } from '../makeIcon';

export const Templates = makeIcon(data, 'templates', 'Templates');

export default Templates;
